<router-outlet />
@if (loader.visible()) {
  <div
    class="fixed inset-0 z-99999 flex items-center justify-center bg-ink-x1"
    role="status"
    aria-live="polite"
    [attr.aria-label]="'common.loading' | translate"
    data-ui="block-ui"
  >
    <app-loader />
  </div>
}
